import {InfiniteData} from '@tanstack/react-query';
import {ReactNode} from 'react';
import {DayOfWeekList} from '../../../graphql/generated/types';
import {useInfiniteDayOfWeekListQuery} from '../../../wrapper/tabWrapper';
import {DayOfWeekCommonProps, DayOfWeekReferenceKeyProps} from '../type';

interface Props extends DayOfWeekCommonProps, DayOfWeekReferenceKeyProps {
  children: (params: {
    data: InfiniteData<DayOfWeekList>;
    isFetching: boolean;
    hasNextPage: boolean;
    fetchNextPage: VoidFunction;
  }) => ReactNode;
}

export const DayOfWeekInfiniteListContainer = ({
  referenceKey,
  dayId,
  sortType,
  page,
  size,
  children,
}: Props) => {
  const {data, isFetching, hasNextPage, fetchNextPage} =
    useInfiniteDayOfWeekListQuery(
      {
        referenceKey,
        dayUid: dayId,
        sortType,
        page,
        size,
      },
      {
        initialPageParam: 0,
        getNextPageParam: (lastPage, pages) => {
          if (lastPage && (lastPage.isEnd || lastPage.list.length === 0)) {
            return undefined;
          }
          return pages.length;
        },
      }
    );

  if (!data) {
    return null;
  }

  return (
    <>
      {children({
        data,
        isFetching,
        hasNextPage,
        fetchNextPage,
      })}
    </>
  );
};
